import { createPortal } from "react-dom";

import styled from "styled-components/macro";

import FnrConfetti from "UI/FnrConfetti";

import { useClearConfetti, useConfettiActive } from "./confettiStore";

export default function Confetti() {
  const active = useConfettiActive();
  const clearConfetti = useClearConfetti();

  if (!active) return null;

  const overlay = document.getElementById("FnrOverlayHolder");

  return createPortal(
    <ConfettiWrapper>
      <FnrConfetti
        recycle={false}
        numberOfPieces={400}
        tweenDuration={15000}
        onConfettiComplete={clearConfetti}
      />
    </ConfettiWrapper>,
    overlay || document.body
  );
}

const ConfettiWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  pointer-events: none;
`;
